// extracted by mini-css-extract-plugin
export default {"labelGroup":"styles_labelGroup__NMMoT","label":"styles_label__hGWRv","necessityIndicator":"styles_necessityIndicator__CNVO9"};